import { connect, TAdFoxBannerSizeProps } from '@cian/adfox-component';
import { InitialAdfoxAnalyticsPayload, PParams, withAdfoxPostViewAnalytics } from '@cian/postview-analytics-utils';
import * as React from 'react';

import { OwnTemplates } from './OwnTemplates';
import { usePuids } from './helpers';

export const AdfoxBannerConnected = connect(OwnTemplates);

export interface IAdfoxBannerContainerProps {
  postViewAnalyticsData: Pick<
    InitialAdfoxAnalyticsPayload,
    'place' | 'place__DEPRECATED' | 'name__DEPRECATED' | 'extra__DEPRECATED' | 'isSp'
  >;
  pParams: PParams;
  size: TAdFoxBannerSizeProps;
  position?: number;
  galleryPosition?: number;
  onStub?: () => void;
}

export function AdfoxBannerContainer({
  size,
  pParams,
  postViewAnalyticsData,
  position,
  galleryPosition,
  onStub,
}: IAdfoxBannerContainerProps) {
  const puids = usePuids();

  return React.useMemo(() => {
    const AdfoxWithPostView = withAdfoxPostViewAnalytics(AdfoxBannerConnected, {
      position,
      galleryPosition,
      ...postViewAnalyticsData,
    });

    return <AdfoxWithPostView {...size} params={{ ...pParams, ...puids }} onStub={onStub} />;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
